import { defineStore } from 'pinia';
import UserAuthService from "../services/user-auth.service";
import List_Coureurs from "../classes/Coureurs/List_Coureurs.class";
import { useMainStore } from './mainStore';
import UserService from '../services/user.service';

export const useAuthUserStore = defineStore('authUser', {
    state: () => {
        const user = JSON.parse(localStorage.getItem("sportips_auth_user"));
        let initialState = {
            isLogged: user ? true : false,
            userData: user ? user : null,
            list_coureurs: null,
        }
        return initialState;
    },
    actions: {

        /**
         * Logs in a user with the provided login details.
         * 
         * @param {Object} login_details - The login details of the user.
         * @returns {Promise<boolean|Object>} - Returns true if login is successful, otherwise returns the response object.
         */
        async login(login_details) {
            let res = await UserAuthService.login(login_details);
            if (res.success) {
                this.isLogged = true;
                this.userData = res.user;
                localStorage.setItem("sportips_auth_user", JSON.stringify(res.user));
                return true;
            }
            return res;
        },


        /**
         * Registers a new user.
         * 
         * @param {Object} user - The user object containing registration details.
         * @returns {Promise<Object>} The response object from the registration service.
         */
        async register(user) {
            let res = await UserAuthService.register(user);
            if (res.success) {
                this.isLogged = true;
                this.userData = res.user;
                localStorage.setItem("sportips_auth_user", JSON.stringify(res.user));
            }
            return res;
        },

        /**
         * Logs out the current user by performing the following actions:
         * - Sets the `isLogged` property to `false`.
         * - Clears the `userData` property.
         * - Removes the user data from local storage.
         */
        logout() {
            this.isLogged = false;
            this.userData = null;
            localStorage.removeItem("sportips_auth_user");
        },

        /**
         * Logs in a user using an authentication token.
         *
         * @param {string} auth_token - The authentication token.
         * @returns {Promise<Object>} The response object from the login attempt.
         * @property {boolean} success - Indicates if the login was successful.
         * @property {Object} user - The user data if the login was successful.
         */
        async loginWithAuthToken(auth_token) {
            let res = await UserAuthService.loginWithAuthToken(auth_token);
            if (res.success) {
                this.isLogged = true;
                this.userData = res.user;
                localStorage.setItem("sportips_auth_user", JSON.stringify(res.user));
            }
            return res;
        },

        async loadAdminToken() {
            const mainStore = useMainStore();
            if (!this.isSportips) {
                return null;
            }
            let res = await UserService.getAdminToken(mainStore.module.base);
            return res ? res : null;
        },

        async fetch_coureurs() {
            let coureurs = new List_Coureurs();
            await coureurs.fetch();
            this.list_coureurs = coureurs;
        }
    },
    getters: {
        isSportips() {
            return this.userData?.privilege == 'sportips';
        },
        has_coureurs() {
            return this.list_coureurs?.list.length > 0;
        },
        userMail() {
            return this.userData?.mail;
        },
        userId() {
            return this.userData?.id;
        }


    },
});